<template>
    <el-card shadow="never" class="aui-card--fill">
    	<el-row style="background-color: #F3F4F4;">
    		<el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
    			<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />
    			结算申请
    		</el-col>
    		<el-col :xs="24" :md="18" style="text-align: right;">
    			<el-button v-no-more-click  type="primary" v-show="dataForm.status===0" v-if="$hasPermission('plat:platapplyapproval:submit')" :loading="loadingbut" @click="dataFormSubmitHandle(1)">提交</el-button>

					<el-upload style="display: inline;margin:0px 10px;"
					 v-show="dataForm.status===0" v-if="$hasPermission('plat:platapplyapproval:export')"
					  :show-file-list="false"
					   :http-request='uploadFile'><el-button type="info">导入</el-button>
					</el-upload>

    			<el-button v-no-more-click  type="info" v-show="dataForm.status===0" v-if="$hasPermission('plat:platapplyapproval:save')" :loading="loadingbut" @click="dataFormSubmitHandle(0)">保存</el-button>
    			<el-button v-no-more-click  v-if="$hasPermission('plat:platapplyapproval:checked')" v-show="dataForm.status===1" type="primary"
    			           @click="dataFormStatusHandle('1',dataForm.id)">通过审核
    			</el-button>
    			<el-button v-no-more-click  v-if="$hasPermission('plat:platapplyapproval:checked')" v-show="dataForm.status===1" type="primary"
    			           style="background-color: thistle" @click="dataFormStatusHandle('0',dataForm.id)">驳回
    			</el-button>
				<el-button v-no-more-click  v-if="$hasPermission('plat:platapplyapproval:pay')" v-show="dataForm.status===2" type="primary"
				           style="background-color: thistle" @click="dataFormpayHandle('multi',dataForm.id)">批量支付
				</el-button>
				<el-button @click="init()">刷新</el-button>
				<el-button @click="$router.go(-1)">返回列表</el-button>
				<a v-if="$hasPermission('plat:platapplyapproval:export')"  v-show="dataForm.status===0" :href="`${publicPath}template/jsmb.xlsx`" target="_blank" download="jsmb.xlsx" style="text-decoration: underline;color:#3878F4;margin-left:20px;">导入模板下载</a>

			</el-col>
    	</el-row>
    	<div style="padding: 20px 0px;">
		<el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
                 :label-width="$i18n.locale === 'en-US' ? '10px' : '140px'">

            <div style="border-bottom:1px solid #F3F4F4;height: 62px;">
				<el-rows>
				    <el-col :span="6">
				        <el-form-item label="结算主体名称:" prop="dealBody">

							{{dataForm.dealBody}}
				        </el-form-item>
				    </el-col>
				    <el-col :span="6">
				        <el-form-item label="统一社会信用编码:" prop="taxCode">
				            {{dataForm.taxCode}}
				        </el-form-item>
				    </el-col>
				    <el-col :span="6">
				        <el-form-item label="任务编号:">
				            {{dataForm.taskCode}}
				        </el-form-item>
						<!-- <el-form-item label="发票项目:" v-show="dataForm.status == 1">
							<el-input v-model="dataForm.ticketPro" type="text"></el-input>
						</el-form-item>
						<el-form-item label="发票项目:" v-show="dataForm.status> 1">
							<el-input v-model="dataForm.ticketPro" type="text" :disabled="true"></el-input>
						</el-form-item> -->
				    </el-col>
				</el-rows>
			</div>
            <div style="text-align: center;font-size: 16px;font-weight: bold;color: #121212;padding: 29px 0px;">{{dataForm.title}}</div>

			<div style="padding:33px">
				<div style="font-size: 14px;font-weight: bold;">{{dataForm.client}}</div>
				<div style="font-size: 12px;font-weight: bold;margin:40px 0px 16px 32px;">{{dataForm.beizhu}}</div>
				<div style="background: #FBFAFA;border: 1px solid #D7D7D7;;">
					<el-row>
						<el-col :span="2" style="text-align: center;line-height: 270px;">说明</el-col>
						<el-col :span="22" style="min-height: 270px;border-left: 1px solid #D7D7D7;font-size: 12px;font-weight: 400;color: #404040;line-height: 30px;padding:19px 29px;">
							<div v-for="item in remark">{{item}}</div>
						</el-col>
					</el-row>
					<el-row style="border-top: 1px solid #D7D7D7;">
						<el-col :span="2" style="text-align: center;line-height: 50px;">基本信息</el-col>
						<el-col :span="2" style="text-align: center;line-height: 50px;border-left: 1px solid #D7D7D7;">支付周期</el-col>
						<el-col :span="20" style="line-height: 50px;border-left: 1px solid #D7D7D7;padding-left: 20px;">{{dataForm.dealCycle}}</el-col>
					</el-row>
				</div>
			</div>

            <el-table :data="dataForm.platDealDetailDTOList" style="width: 100%;" :cell-style="getRowClass">
                <el-table-column prop="realName" label="自由职业者姓名" header-align="center" align="center"></el-table-column>
                <el-table-column prop="phone" label="手机号" header-align="center" align="center"></el-table-column>
                <el-table-column prop="idCard" label="身份证号" header-align="center" align="center"></el-table-column>
                <el-table-column prop="idCardType" label="证件类型" header-align="center" align="center"></el-table-column>
                <el-table-column prop="paymentType" label="支付类型" header-align="center" align="center"></el-table-column>

				<el-table-column prop="bankNo" label="收款账号" header-align="center" align="center"></el-table-column>

				<el-table-column prop="bankName" label="开户银行全称/支付宝" header-align="center" align="center"></el-table-column>

				<el-table-column prop="dealMoney" label="实发金额" header-align="center" align="center"></el-table-column>

				<el-table-column prop="unitPrice" label="单价" header-align="center" align="center"></el-table-column>

				<el-table-column prop="quantity" label="数量" header-align="center" align="center"></el-table-column>
				<el-table-column prop="settlementStart" label="结算账期开始时间" header-align="center" align="center"></el-table-column>
				<el-table-column prop="settlementEnd" label="结算账期结束时间" header-align="center" align="center"></el-table-column>
                <el-table-column prop="postName" label="项目名称岗位" header-align="center" align="center"></el-table-column>
				<el-table-column prop="remark" label="成果交付描述" header-align="center" align="center"></el-table-column>
				<el-table-column v-if="$hasPermission('plat:platapplyapproval:pay') && dataForm.status>=2" :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
					<template slot-scope="scope">
						<el-button type="text" v-if="scope.row.status != 1" size="small" @click="payHandle(scope.row.dealMoney,scope.row.realName,scope.row.id)">
							支付
						</el-button>
						<el-button type="text" v-else size="small">
							已支付
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div style="text-align: center;line-height: 40px;color: #3F3F3F;font-size: 12px;font-weight: bold;">合计：{{dataForm.money}}</div>

        </el-form>
		<el-row style="border-top: 5px solid #F3F4F4;" v-if="dataForm.platDealProcessDTOList.length > 0">
			<div style="font-size: 14px;font-weight: bold;color: #333333;line-height: 40px;padding:30px 30px 0px;">结算单状态</div>
			<div style="line-height: 25px;padding: 10px 0;font-size: 12px;padding:0px 30px;">
				<p style="margin: 0;line-height: 50px;border-bottom:1px solid #F3F4F4;">
						结算申请编号<span style="margin-left: 40px;">{{dataForm.dealCode}}</span>
					</p>
					<p style="margin: 0;line-height: 50px;border-bottom:1px solid #F3F4F4;" v-for="(value,key) in dataForm.platDealProcessDTOList">
						<!-- <span style="width: 10px;height: 10px;border-radius: 5px;background-color: #3371F1;display: inline-block;margin: 0 15px;"></span> -->
						{{value.createDate}}
						<span style="margin-left: 40px;" v-if="value.status == 0"> 草稿</span>
						<span style="margin-left: 40px;" v-if="value.status == 1">提交</span>
						<span style="margin-left: 40px;" v-if="value.status == 2">审核</span>
						<span style="margin-left: 40px;" v-if="value.status == 3">支付</span>
						<span style="margin-left: 40px;">{{value.content}}</span>
						</p>
			</div>
		</el-row>
		<set-pay v-if="setpayVisible" ref="SetPay" @refreshDataList="getidInfo"></set-pay>
    </div>

    </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import SetPay from './set-pay'
import debounce from 'lodash/debounce'
import XLSX from 'xlsx'
export default {
  data () {
    return {
      setpayVisible: false,
      loadingbut: false,
      mixins: [mixinViewModule],
      mixinViewModuleOptions: {
				    getDataListURL: '/sys/plat/deal/detail/page',
				    getDataListIsPage: true,
				    deleteURL: '/sys/plat/ticket/pick',
				    deleteIsBatch: true
      },
      publicPath: process.env.BASE_URL,
      remark: '',
      typedata: 1,
      status: '',
      dataForm: {
        id: '',
        taskId: '', // 父页面传值过来
        dealCode: '', // dealCode
        dealBody: '', // 结算主体名称
        taxCode: '', // 统一社会信用编码
        dealType: '', //	结算方式
        money: 0, //	结算费用
        unpaidMoney: 0,
        status: '',
        dealDate: '', //	结算日期
        creator: '', // creator
        createDate: '', // 创建时间
        updater: '', // 更新人
        updateDate: '', //	更新时间
        platDealDetailDTOList: [],
        platDealProcessDTOList: [],
        title: '委托代发业务模板-经营所得明细',
        beizhu: '根据委托方与财天下所签的《共享经济平台综合服务协议》，委托方确认经营所得明细如下：', // XXXXXXXXXXX：（委托方）
        dealCycle: '',
        client: '', // XXXXXXXXXXX：（委托方）
        remark: '',
        taskCode: ''
      }
    }
  },
  created () {
    this.typedata = this.$route.params.typedata || 1
    if (this.typedata == 1) {
      this.dataForm.taskId = this.$route.params.id || ''
    } else {
      this.dataForm.id = this.$route.params.id || ''
    }
    this.init()
  },
  components: {
    SetPay
  },
  computed: {
    dataRule () {
    }
  },
  methods: {
    init () {
      this.$nextTick(() => {
        if (this.typedata == 1) {
          this.getInfo()
        } else {
          this.getidInfo()
        }
      })
    },
    getRowClass ({ row, column, rowIndex, columnIndex }) {
      if (row.userId == null) {
        return 'background:red;color:#fff;'
      } else {
        return 'background:#fff;'
      }
    },
    uploadFile (params) {
      console.log(params)
			  const _file = params.file
			  if (_file.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && _file.type != 'application/vnd.ms-excel') {
				  this.$message.warning('文件格式错误！')
				  return false
			  }
			  const fileReader = new FileReader()
			  fileReader.onload = (ev) => {
        try {
				  const data = ev.target.result
				  const workbook = XLSX.read(data, {
            type: 'binary'
				  })

				  const sheetArray = XLSX.utils.sheet_to_json(workbook.Sheets['Sheet1'])
				  // 若当前sheet没有数据，则continue
				  if (sheetArray.length == 0) {
            this.$message.warning('文件没有内容！')
				    return false
				  }
				  let dataFormData = this.dataForm
				  for (let item in sheetArray[0]) {
					  dataFormData.title = item
					  dataFormData.client = sheetArray[0][item]
				  }
				  for (let item in sheetArray[1]) {
					  dataFormData.beizhu = sheetArray[1][item]
				  }
				  for (let item in sheetArray[2]) {
					  this.remark = sheetArray[2][item].replace(/\n/g, '</br>').split('</br>')
				  }
				  dataFormData.dealCycle = sheetArray[3]['__EMPTY_1']
				  dataFormData.platDealDetailDTOList = []
				  let money = 0
				  for (let info in sheetArray) {
					  if (info < 5) {
						  continue
					  }
            let rowTable = {}
					  for (let item in sheetArray[info]) {
              console.log(item)
              if (item.replace('__EMPTY_', '') == item && item != '__EMPTY') {
                continue
              }
              let i = 0
              if (item == '__EMPTY') {
                i = 1
              } else {
                i = Number(item.replace('__EMPTY_', '')) + 1
              }

              switch (i) {
                case 1:
                  rowTable.realName = sheetArray[info][item]
                  break
                case 2:
                  rowTable.phone = sheetArray[info][item]
                  break
                case 3:
                  rowTable.idCard = sheetArray[info][item]
                  break
                case 4:
                  rowTable.idCardType = sheetArray[info][item]
                  break
                case 5:// 支付类型
                  rowTable.paymentType = sheetArray[info][item]
                  break
                case 6:// 收款账号
                  rowTable.bankNo = sheetArray[info][item]
                  break
                case 7:// 收款账号
                  rowTable.bankName = sheetArray[info][item]
                  break
                case 8:// 收款账号
                  rowTable.dealMoney = sheetArray[info][item]
                  money = money + Number(rowTable.dealMoney)
                  break
                case 9:// 收款账号
                  rowTable.unitPrice = sheetArray[info][item]
                  break
                case 10:// 收款账号
                  rowTable.quantity = sheetArray[info][item]
                  break
                case 11:// 收款账号
                  rowTable.settlementStart = sheetArray[info][item]
                  break
                case 12:// 收款账号
                  rowTable.settlementEnd = sheetArray[info][item]
                  break
                case 13:// 收款账号
                  rowTable.postName = sheetArray[info][item]
                  break
                case 14:// 收款账号
                  rowTable.remark = sheetArray[info][item]
                  break
              }
					  }
					  dataFormData.platDealDetailDTOList.push(rowTable)
				  }

				  this.$http.post('/sys/plat/deal/approval/checkDetail', dataFormData.platDealDetailDTOList).then(({ data: res }) => {
					  console.log(res)
            dataFormData.platDealDetailDTOList = res.data
            this.dataForm = dataFormData
            this.dataForm.money = money.toFixed(2)
				  }).catch(() => {})
        } catch (e) {
				  this.$message.warning('文件类型不正确！')
        }
			  }
			  fileReader.readAsBinaryString(_file)
			  params.onSuccess(params)
    },
    addOrUpdateHandle () {
      this.$ref.addOrUpdate.visible = true
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/plat/deal/approval/getByTaskId?taskId=` + this.dataForm.taskId).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }

        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        this.remark = res.data.remark.split('</br>')
      }).catch(() => {})
    },
    getidInfo () {
      this.$http.get(`sys/plat/deal/approval/` + this.dataForm.id).then(({ data: res }) => {
				    if (res.code !== 0) {
				    	return this.$message({
				    	  message: res.msg,
				    	  type: 'error',
				    	  duration: 500,
				    	  onClose: () => {
				    		this.$router.back(-1)
				    	  }
				    	})
				    }

				    this.dataForm = {
				        ...this.dataForm,
				        ...res.data
				    }
        this.status = res.data.status
        this.remark = res.data.remark.split('</br>')
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle (status) {
      if (this.dataForm.platDealDetailDTOList.length == 0) {
        return this.$message.error('无保存信息')
      }
      for (let s = 0; s < this.dataForm.platDealDetailDTOList.length; s++) {
        if (this.dataForm.platDealDetailDTOList[s].userId == null) {
          return this.$message.error('红色标识的数据不合格,请及时更正')
        }
      }
      this.loadingbut = true
      let oldstatus = this.dataForm.status
      this.dataForm.status = status
      this.dataForm.remark = this.remark.join('</br>')
      this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/plat/deal/approval', this.dataForm).then(({ data: res }) => {
        this.loadingbut = false
				  if (res.code !== 0) {
					  this.dataForm.status = oldstatus
				    return this.$message.error(res.msg)
				  }
				  this.$message({
				    message: this.$t('prompt.success'),
				    type: 'success',
				    duration: 500,
				    onClose: () => {
            this.dataForm.id = res.data
            this.typedata = 2
            this.getidInfo()
				    }
				  })
      }).catch(() => {})
    },
    dataFormStatusHandle: debounce(function (inStatus, id) {
      let _this = this
      // if(this.dataForm.ticketPro == "" || this.dataForm.ticketPro == null ){
      // 	return this.$message.error("请输入发票项目");
      // }
      console.log(this.dataForm.ticketPro)
      this.$prompt('请输入审核理由', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消'
      }).then(({ value }) => {
        let pass = inStatus == 1 ? 'pass' : 'return'
				  this.$http.post('/sys/plat/deal/approval/audit', { id: id, result: pass, reason: value, ticketPro: this.dataForm.ticketPro }, {
				      headers: {
				          'content-type': 'application/json;charset=utf-8'
				      }
				  }).then(({ data: res }) => {
				      if (res.code !== 0) {
				          return this.$message.error(res.msg)
				      }
				      this.$message({
				          message: this.$t('prompt.success'),
				          type: 'success',
				          duration: 500,
				          onClose: () => {
							  this.init()
				          }
				      })
				  }).catch(() => {
				  })
      })
    }),
    dataFormpayHandle (type, id) {
      this.setpayVisible = true
      this.$nextTick(() => {
        this.$refs.SetPay.init()
					  this.$refs.SetPay.dataForm.type = type
					  this.$refs.SetPay.dataForm.id = id
					  this.$refs.SetPay.money = this.dataForm.unpaidMoney
					  this.$refs.SetPay.id = this.dataForm.id
      })
    },
    payHandle (money, name, id) {
      this.setpayVisible = true
      this.$nextTick(() => {
        this.$refs.SetPay.init()
				  this.$refs.SetPay.dataForm.type = 'single'
				  this.$refs.SetPay.dataForm.id = id
				  this.$refs.SetPay.money = money
				  this.$refs.SetPay.name = name
				  this.$refs.SetPay.id = this.dataForm.id
      })
    }
  }
}
</script>
